/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Sharp_Cod_LiftInputs */

const en_happy_sharp_cod_lift = /** @type {(inputs: Happy_Sharp_Cod_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create entries`)
};

const de_happy_sharp_cod_lift = /** @type {(inputs: Happy_Sharp_Cod_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einträge erstellen`)
};

/**
* | output |
* | --- |
* | "Create entries" |
*
* @param {Happy_Sharp_Cod_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_sharp_cod_lift = /** @type {((inputs?: Happy_Sharp_Cod_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Sharp_Cod_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_sharp_cod_lift(inputs)
	return de_happy_sharp_cod_lift(inputs)
});